import React, { useState } from "react";
import { Seo } from "../components/seo/Seo";
import { Header } from "../components/layout/Header";
import { HeroSection } from "../components/home/HeroSection";
import { Footer } from "../components/home/Footer";
import { InquiryModal } from "../components/home/InquiryModal";
import { ASSETS } from "../constants/assets";

export function BalkanFinXpertPage(): React.ReactElement {
  const [inquiryModalOpen, setInquiryModalOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Seo
        path="/"
        titleKey="seo.home.title"
        descriptionKey="seo.home.description"
      />
      <Header logoImageSrc={ASSETS.logo} logoImageAlt="BalkanFinXpert" />

      <InquiryModal
        open={inquiryModalOpen}
        onClose={() => setInquiryModalOpen(false)}
      />

      <main className="flex-1">
        <HeroSection onOpenInquiry={() => setInquiryModalOpen(true)} />
        {/* <AboutSection /> */}
      </main>
      <Footer />
    </div>
  );
}

export default BalkanFinXpertPage;
